import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { EnquiryPurposeJson } from "../../../DynamicFormsJson/MastersJSON/enquiryPurpose";

class EnquiryPurposeForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <DynamicForm
                    formPath={EnquiryPurposeJson.formPath}
                    screenTitle={EnquiryPurposeJson.screenTitle}
                    fieldMeta={EnquiryPurposeJson.fieldMeta}
                    tableColumnsToFilter={EnquiryPurposeJson.tableColumnsToFilter}
                    apiBaseURL={EnquiryPurposeJson.apiBaseURL}
                    baseIdColumn={EnquiryPurposeJson.baseIdColumn}
                    type={0}
                    isLog={true}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryPurposeForm);